module.exports = __webpack_public_path__ + "img/拓扑图@2x.d471245c.png";